import React from 'react';

type CartDrawerApi = {
  openCart: () => void;
  closeCart: () => void;
};

const CartDrawerContext = React.createContext<CartDrawerApi | undefined>(undefined);

export function CartDrawerProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: CartDrawerApi;
}) {
  return <CartDrawerContext.Provider value={value}>{children}</CartDrawerContext.Provider>;
}

export function useCartDrawer(): CartDrawerApi {
  const ctx = React.useContext(CartDrawerContext);
  if (!ctx) throw new Error('useCartDrawer must be used within CartDrawerProvider');
  return ctx;
}

